export default __webpack_public_path__ + "static/media/instructionsCardImage.00e5d762.svg";